import { TDoctorsRankingMetric } from "./doctors-ranking-chart.constant";

export const AnalyticsConstant = {
  EVENTS: {
    LOGIN: "login",
  },

  EVENT_TYPES: {
    COMPARATIVE_DOCTOR_PAGE_ACCESSED: "ComparativeDoctorPageAccessed",
    COMPARATIVE_DOCTOR_CHART_VIEW_CHANGED: "ComparativeDoctorChartViewChanged",
  },

  ENTITY_TYPES: {
    COMPARATIVE_DOCTOR: "ComparativoMedico",
  },

  EVENT_PARAMS: {
    METHOD: "method",
    USER_ROLE: "user_role",
  },

  USER_PROPERTIES: {
    ROLE: "user_role",
    TENANT_ID: "tenant_id",
    TENANT_NAME: "tenant_name",
    FIRST_ACCESS: "first_access",
  },

  VALUES: {
    LOGIN_METHOD_CREDENTIALS: "credentials",
  },
} as const;

export const AnalyticsChartViewConstant: Record<TDoctorsRankingMetric, string> =
  {
    adherence: "ProtocolAdherence",
    patients: "PatientsByDoctor",
  };

export const AnalyticsEventType = {
  patientListSearchedByName: 100,
  patientListFilteredByPathology: 101,
  patientListFilteredByMedicine: 102,
  patientListFilteredByTreatmentStatus: 103,
  patientListFilteredByTag: 104,
} as const;

export type TAnalyticsEventName =
  (typeof AnalyticsConstant.EVENTS)[keyof typeof AnalyticsConstant.EVENTS];

export type TAnalyticsEventType =
  | (typeof AnalyticsConstant.EVENT_TYPES)[keyof typeof AnalyticsConstant.EVENT_TYPES]
  | (typeof AnalyticsEventType)[keyof typeof AnalyticsEventType];
